import { render, staticRenderFns } from "./Hamburger.vue?vue&type=template&id=04bb8b70&scoped=true"
import script from "./Hamburger.vue?vue&type=script&lang=js"
export * from "./Hamburger.vue?vue&type=script&lang=js"
import style0 from "./Hamburger.vue?vue&type=style&index=0&id=04bb8b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb8b70",
  null
  
)

export default component.exports